import PublicationsModalBody from "./PublicationsModalBody";

export default PublicationsModalBody;
